import React from 'react';
import TcPaper from '../TcPaper';

interface LoadingScreenProps {
    message?: string;
    classNameStyle?: string;
    showPaper?: boolean;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
    message = "Loading...", 
    classNameStyle = "main-content-wrapper bg-black",
    showPaper = true  // Whether to wrap content in TcPaper (defaults to true)
}) => {
    const loadingContent = (
        <div className="flex items-center justify-center py-8">
            <div className="text-center">
                <div className="w-8 h-8 border-2 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                <p className="text-gray-400">{message}</p>
            </div>
        </div>
    );

    if (showPaper) {
        return (
            <div className={classNameStyle}>
                <TcPaper classNameStyle="my-2">
                    {loadingContent}
                </TcPaper>
            </div>
        );
    }

    return (
        <div className={classNameStyle}>
            {loadingContent}
        </div>
    );
};

export default LoadingScreen; 